/**
 * The language (see `helpers/i18n.ts`) for function components: they re-render when it changes, e.g. after a login of a
 * user with another locale, also in another tab.
 */
import {useSyncExternalStore} from 'react';

import type {Language, Translate} from '../helpers/i18n';
import {getLanguage, getTranslator, toLanguage} from '../helpers/i18n';
import {getPickedLanguage, getPolyshoppenUser, subscribe} from '../helpers/session';

/** The language the logged in user picked on this terminal, `null` when they follow the locale of their account. */
export const usePickedLanguage = (): Language | null =>
    useSyncExternalStore(subscribe, () => {
        const user = getPolyshoppenUser();
        const language = null === user ? null : getPickedLanguage(user.id);

        return null === language ? null : toLanguage(language);
    });

/** The language the terminal speaks. */
export const useLanguage = (): Language => useSyncExternalStore(subscribe, getLanguage);

/**
 * Translate into the current language: `const t = useTranslation();` then `t('order.scan')`. The function stays the
 * same until the language changes.
 */
export const useTranslation = (): Translate => getTranslator(useLanguage());
